export enum ObjectType {
  FLAT = 'FLAT',
  HOUSE = 'HOUSE',
  ROOM = 'ROOM',
  GARAGE = 'GARAGE',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER'
}
